export default "__VITE_PUBLIC_ASSET__6100005f__"